import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProfileDdText',
    props: {
        text: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("dd", {
                class: _normalizeClass(props.text == '' ? 'empty' : 'profile_text')
            }, [
                _createElementVNode("span", null, _toDisplayString(props.text), 1)
            ], 2));
        };
    }
});
